<template>
  <div class="terms-checkbox">
    <checkbox
      v-model="buyer.acceptTermsAndConditions"
      :error-messages="{
        sameAs:
          'Za nastavak kupnje potrebno je prihvatiti CoreEvent uvjete korištenja i uvjete prodaje.',
      }"
      :validator="vs.buyer.acceptTermsAndConditions"
    >
      <div>
        {{ $t('acceptCoreEvent') }}
        <a id="terms" :href="`${landingURL}/en/terms`" target="_blank">{{ $t('termsOfUse') }}</a>
        {{ $t('and') }}
        <a id="sale" :href="`${landingURL}/sale`" target="_blank">{{ $t('conditionsOfSale') }}</a>. *
      </div>
    </checkbox>
    <checkbox v-model="buyer.getSubscription">
      <p class="about-subscription">
        {{ $t('subscription1') }} “{{ organization.publicName }}”
        {{ $t('subscription2') }}
      </p>
    </checkbox>
  </div>
</template>

<script>
import { landingURL } from '@/utils'

export default {
  name: 'user-permissions',
  props: {
    vs: {
      type: Object,
      default: () => {},
    },
    organization: {
      type: Object,
      default: () => {},
    },
    buyer: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      landingURL,
    }
  },
}
</script>

<style scoped></style>
